import Q from 'q';

import type { ActionContext } from 'js/lib/ActionContext';

import courseSchedulePromiseFactory from 'pages/open-course/common/promises/courseSchedule';

import CourseScheduleStoreClass from 'bundles/ondemand/stores/CourseScheduleStore';
// TODO(lewis): Replace with more well defined error. We should NOT use a SSR error here.
import JSApplicationError from 'bundles/ssr/lib/errors/JSApplicationError';

export default (actionContext: ActionContext, courseId: string): Q.Promise<any> => {
  if (actionContext.getStore(CourseScheduleStoreClass).hasLoaded()) {
    return Q();
  }
  actionContext.dispatch('LOADING_COURSE_SCHEDULE');

  if (!courseId) {
    return Q.reject(new JSApplicationError('courseId must be provided.'));
  }

  return courseSchedulePromiseFactory(courseId)
    .then((data) => {
      actionContext.dispatch('LOAD_COURSE_SCHEDULE', data);
    })
    .catch((error) => {
      actionContext.dispatch('LOAD_COURSE_SCHEDULE_ERROR', error);
    });
};
